import { render, staticRenderFns } from "./MypageBlockedUserListPage.vue?vue&type=template&id=2bd92fb6&scoped=true"
import script from "./MypageBlockedUserListPage.vue?vue&type=script&lang=ts"
export * from "./MypageBlockedUserListPage.vue?vue&type=script&lang=ts"
import style0 from "./MypageBlockedUserListPage.vue?vue&type=style&index=0&id=2bd92fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd92fb6",
  null
  
)

export default component.exports